import { Component, Inject, Input, Optional } from '@angular/core';

import { BadgeComponent } from '../badge/badge.component';
import { IconComponent } from '../icon';
import { RadioBaseDirective } from '../radio-badge/radio-base.directive';
import { RadioCardGroupComponent, SB_RADIO_CARD_GROUP } from '../radio-card-group/radio-card-group.component';

@Component({
  standalone: true,
  selector: 'sb-radio-card',
  templateUrl: './radio-card.component.html',
  imports: [IconComponent, BadgeComponent],
})
export class RadioCardComponent extends RadioBaseDirective {
  @Input()
  badge?: string;

  constructor(@Optional() @Inject(SB_RADIO_CARD_GROUP) override radioGroup: RadioCardGroupComponent) {
    super(radioGroup);
  }
}
